import { inject, Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { BehaviorSubject, filter, map, Observable, pairwise, startWith, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteHistoryService {
  private readonly router = inject(Router);

  public previousRoute = new BehaviorSubject('');
  public history$: Observable<string> = this.previousRoute.asObservable();

  constructor() {
    this.router.events
      .pipe(
        filter(e => e instanceof RoutesRecognized),
        map((event: RoutesRecognized) => event.urlAfterRedirects),
        startWith(''),
        pairwise()
      )
      .subscribe(([previousUrl, _]: [string, string]) => {
        this.previousRoute.next(previousUrl);
      })
  }
}
